// extracted by mini-css-extract-plugin
export default {"info":"event-info_info__miGfV","infoItem":"event-info_infoItem__192BQ","disabledText":"event-info_disabledText__Iu-G3"};